export const STORE_MASK_CHATGROUPS_FILES_LIST_GET = 'myNetworking/chatgroups/fileslist/get';
export const COMMUNITY = 'Community';
